/* daniels-collection.js – Daniel's Leather */
(function () {
  'use strict';

  const $ = (s, ctx = document) => ctx.querySelector(s);
  const $$ = (s, ctx = document) => [...ctx.querySelectorAll(s)];

  /* ── 1. VIEW TOGGLE (desktop: 2/4 cols, mobile: 1/2 cols) ── */
  const grid        = $('#danielsProductGrid');
  const viewBtns    = $$('.daniels-view-btn');
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  function getStorageKey() {
    return mobileQuery.matches ? 'danielsGridColsMobile' : 'danielsGridCols';
  }

  function getBtnCols(btn) {
    return mobileQuery.matches ? (btn.dataset.mobileCols || btn.dataset.cols) : btn.dataset.cols;
  }

  function setGridCols(cols) {
    if (!grid) return;
    grid.className = grid.className.replace(/cols-\d/, '').trim() + ` cols-${cols}`;
    viewBtns.forEach(b => b.classList.toggle('active', getBtnCols(b) === cols));
  }

  function applySavedCols() {
    const defaultCols = mobileQuery.matches ? '2' : '4';
    const savedCols   = localStorage.getItem(getStorageKey()) || defaultCols;
    setGridCols(savedCols);
  }

  viewBtns.forEach(btn => btn.addEventListener('click', () => {
    const cols = getBtnCols(btn);
    setGridCols(cols);
    localStorage.setItem(getStorageKey(), cols);
  }));

  applySavedCols();
  mobileQuery.addEventListener('change', applySavedCols); // re-check if a tablet is rotated across the breakpoint

  /* ── 2. LIVE SEARCH (client-side on current page) ── */
  const searchInput = $('#danielsSearchInput');
  if (searchInput) {
    searchInput.addEventListener('input', debounce(function () {
      const q = this.value.trim().toLowerCase();
      $$('.daniels-product-card').forEach(card => {
        const t = card.querySelector('.daniels-card-title');
        card.style.display = (!q || (t && t.textContent.toLowerCase().includes(q))) ? '' : 'none';
      });
    }, 250));
  }

  /* ── 3. DRAWER ── */
  const filterBtn      = $('#danielsFilterBtn');
  const drawer         = $('#danielsFilterDrawer');
  const overlay        = $('#danielsFilterOverlay');
  const closeBtn       = $('#danielsDrawerClose');
  const resetBtn       = $('#danielsResetBtn');
  const showResultsBtn = $('#danielsShowResults');

  if (filterBtn) filterBtn.addEventListener('click', openDrawer);
  if (closeBtn)  closeBtn.addEventListener('click',  closeDrawer);
  if (overlay)   overlay.addEventListener('click',   closeDrawer);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  function collapseAllSections() {
    $$('.daniels-filter-section').forEach(section => {
      const toggle = section.querySelector('.daniels-section-toggle');
      section.classList.add('collapsed');
      // Target any content container inside the section (catches all -btns divs)
      section.querySelectorAll('[class*="-btns"]')
        .forEach(el => { el.style.display = 'none'; });
      if (toggle) toggle.textContent = '+';
    });
  }

  function openDrawer() {
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'true');
    // Always collapse all sections on mobile when drawer opens
    if (mobileQuery.matches) collapseAllSections();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    if (filterBtn) filterBtn.setAttribute('aria-expanded', 'false');
  }

  /* ── 4. COLLAPSIBLE SECTIONS ── */
  $$('.daniels-filter-section-header').forEach(header => {
    header.addEventListener('click', () => {
      const section   = header.closest('.daniels-filter-section');
      const toggle    = header.querySelector('.daniels-section-toggle');
      const collapsed = section.classList.toggle('collapsed');
      section.querySelectorAll('[class*="-btns"]')
        .forEach(el => { el.style.display = collapsed ? 'none' : ''; });
      if (toggle) toggle.textContent = collapsed ? '+' : '−';
    });
  });

  /* ── 5. SHOW RESULTS COUNT ── */
  const countEl = $('#danielsResultCount');
  const totalCount = showResultsBtn ? parseInt(showResultsBtn.dataset.total || '0', 10) : 0;

  function updateCount() {
    if (!countEl) return;
    const activeMaterials = $$('.daniels-material-btn.active').map(b =>
      (b.dataset.label || b.textContent).trim().toLowerCase()
    );

    if (activeMaterials.length > 0) {
      // Fetch JSON to get accurate count for material (tag) filter
      const pathParts = window.location.pathname.replace(/\/+$/, '').split('/');
      const collHandle = pathParts[pathParts.length - 1];
      countEl.textContent = '(...)';
      fetch(`/collections/${collHandle}/products.json?limit=250`)
        .then(r => r.json())
        .then(({ products }) => {
          const count = (products || []).filter(p =>
            activeMaterials.some(mat => (p.tags || []).some(tag => tag.toLowerCase().includes(mat)))
          ).length;
          countEl.textContent = `(${count})`;
        })
        .catch(() => { countEl.textContent = ''; });
    } else {
      // No material filter — reset to collection total
      countEl.textContent = totalCount ? `(${totalCount})` : '';
    }
  }

  /* ── 6. SORT BUTTONS ── */
  $$('.daniels-sort-btn').forEach(btn => btn.addEventListener('click', () => {
    $$('.daniels-sort-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }));

  /* ── 7. FILTER TOGGLE BUTTONS ── */
  $$('.daniels-cat-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const isActive = btn.classList.contains('active');
      $$('.daniels-cat-btn').forEach(b => b.classList.remove('active'));
      if (!isActive) btn.classList.add('active');
    });
  });

  $$('.daniels-color-filter-btn, .daniels-size-btn, .daniels-material-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
      updateCount();
    });
  });

  /* ── 8. RESET ── */
  if (resetBtn) {
    resetBtn.addEventListener('click', () => {
      $$('.daniels-cat-btn,.daniels-color-filter-btn,.daniels-size-btn,.daniels-material-btn').forEach(b => b.classList.remove('active'));
      $$('.daniels-sort-btn').forEach(b => b.classList.remove('active'));
      const first = $('.daniels-sort-btn');
      if (first) first.classList.add('active');
      if (countEl) countEl.textContent = totalCount ? `(${totalCount})` : '';
    });
  }

  /* ── 9. SHOW RESULTS ──
     Uses dynamic filter parameters from data-filter-param on each button.
     Uses filter.v.option.* for variant options (color/size).
  ── */
  if (showResultsBtn) {
    showResultsBtn.addEventListener('click', () => {

      const activeSort       = $('.daniels-sort-btn.active');
      const sortVal          = activeSort ? activeSort.dataset.sort : '';
      const activeCollection = $('.daniels-cat-btn.active');

      // Determine base collection path
      let basePath;
      if (activeCollection) {
        const colUrl = activeCollection.dataset.collectionUrl;
        if (colUrl) {
          basePath = new URL(colUrl, window.location.origin).pathname.replace(/\/+$/, '');
        } else {
          basePath = '/collections/' + (activeCollection.dataset.label || activeCollection.textContent)
            .trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        }
      } else {
        const parts = window.location.pathname.replace(/^\/|\/$/g, '').split('/');
        basePath = '/' + parts.slice(0, 2).join('/');
      }

      // Build filter URL with dynamic parameters
      const filterUrl = new URL(window.location.origin + basePath);
      filterUrl.searchParams.delete('page');

      // Apply color filters using data-filter-param from each active button
      $$('.daniels-color-filter-btn.active').forEach(b => {
        const v = (b.dataset.label || '').trim();
        const param = b.dataset.filterParam || 'filter.v.option.color';
        if (v && param) filterUrl.searchParams.append(param, v);
      });

      // Apply size filters using data-filter-param from each active button
      $$('.daniels-size-btn.active').forEach(b => {
        const v = (b.dataset.label || b.textContent).trim();
        const param = b.dataset.filterParam || 'filter.v.option.size';
        if (v && param) filterUrl.searchParams.append(param, v);
      });

      if (sortVal) filterUrl.searchParams.set('sort_by', sortVal);

      // Check if any color/size/material filters are active
      const activeMaterialBtns = $$('.daniels-material-btn.active');
      const hasFilters = $$('.daniels-color-filter-btn.active').length > 0 ||
                         $$('.daniels-size-btn.active').length > 0 ||
                         activeMaterialBtns.length > 0;

      closeDrawer();

      // If navigating to a different collection, do a full page redirect
      if (activeCollection && basePath !== window.location.pathname.replace(/\/+$/, '')) {
        window.location.href = filterUrl.toString();
        return;
      }

      // If no filters active, just apply sort via URL
      if (!hasFilters) {
        window.location.href = filterUrl.toString();
        return;
      }

      // Material filtering: store selection in sessionStorage, redirect to the
      // clean collection URL (no Shopify filter params), then apply client-side
      // on load so the full unfiltered product set is in the DOM.
      if (activeMaterialBtns.length > 0) {
        const activeMaterials = activeMaterialBtns.map(b =>
          (b.dataset.label || b.textContent).trim().toLowerCase()
        );
        sessionStorage.setItem('danielsMaterialFilter', JSON.stringify(activeMaterials));

        // Redirect to clean base URL (strip any existing filter/page params)
        const cleanUrl = new URL(window.location.origin + basePath);
        if (sortVal) cleanUrl.searchParams.set('sort_by', sortVal);
        window.location.href = cleanUrl.toString();
        return;
      }

      // For color/size filters only: use Section Rendering API
      const sectionUrl = new URL(filterUrl.toString());
      sectionUrl.searchParams.set('section_id', 'daniels-collection-products');

      if (grid) {
        grid.style.opacity = '0.4';
        grid.style.pointerEvents = 'none';
      }

      fetch(sectionUrl.toString())
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('#danielsProductGrid');

          if (newGrid && grid) {
            grid.innerHTML = newGrid.innerHTML;
            grid.style.opacity = '';
            grid.style.pointerEvents = '';

            // Re-init Swiper on new cards
            grid.querySelectorAll('.daniels-swiper').forEach(el => {
              if (el.swiper) el.swiper.destroy(true, true);
              const card = el.closest('.daniels-product-card');
              const paginationEl = card ? card.querySelector('.daniels-swiper-pagination') : null;
              const slideCount = el.querySelectorAll('.swiper-slide').length;
              if (window.Swiper) {
                new Swiper(el, {
                  loop: slideCount > 1,
                  allowTouchMove: true,
                  slidesPerView: 1,
                  pagination: paginationEl && slideCount > 1 ? { el: paginationEl, clickable: true } : false,
                });
              }
            });

            // Re-init wishlist buttons
            grid.querySelectorAll('.daniels-wishlist-btn').forEach(btn => {
              btn.addEventListener('click', e => {
                e.preventDefault(); e.stopPropagation();
                if (typeof danielsWishlist === 'function') {
                  danielsWishlist(btn, btn.dataset.pid);
                }
              });
            });

            // Re-init infinite scroll for the freshly filtered grid (new pagination link, if any)
            initInfiniteScroll();

            // Update browser URL without page reload
            window.history.pushState({}, '', filterUrl.toString());

            const cardCount = grid.querySelectorAll('.daniels-product-card').length;
            console.log('[Daniels Filter] Showing', cardCount, 'products');
          } else {
            window.location.href = filterUrl.toString();
          }
        })
        .catch(() => {
          if (grid) { grid.style.opacity = ''; grid.style.pointerEvents = ''; }
          window.location.href = filterUrl.toString();
        });
    });
  }

  /* ── 9. RESTORE ACTIVE STATE FROM URL ──
     Uses filter.v.option.* for variant options.
  ── */
  (function restoreFromUrl() {
    const params = new URLSearchParams(window.location.search);

    // Read the dynamic option names from the hidden element
    const meta = document.getElementById('danielsFilterOptionNames');
    const colorParam = meta ? meta.dataset.colorOption : 'color';
    const sizeParam  = meta ? meta.dataset.sizeOption  : 'size';

    const activeColors    = params.getAll(`filter.v.option.${colorParam}`).map(v => v.toLowerCase());
    const activeSizes     = params.getAll(`filter.v.option.${sizeParam}`).map(v => v.toLowerCase());
    const activeMaterials = params.getAll('filter.p.tag').map(v => v.toLowerCase());

    $$('.daniels-color-filter-btn').forEach(btn => {
      const label = (btn.dataset.label || '').trim().toLowerCase();
      if (activeColors.includes(label)) btn.classList.add('active');
    });

    $$('.daniels-size-btn').forEach(btn => {
      const label = (btn.dataset.label || btn.textContent).trim().toLowerCase();
      if (activeSizes.includes(label)) btn.classList.add('active');
    });

    $$('.daniels-material-btn').forEach(btn => {
      const tags = btn.dataset.tags
        ? btn.dataset.tags.split('|').map(t => t.trim().toLowerCase())
        : [(btn.dataset.label || btn.textContent).trim().toLowerCase()];
      if (tags.some(t => activeMaterials.includes(t))) btn.classList.add('active');
    });

    const sortParam = params.get('sort_by');
    if (sortParam) {
      $$('.daniels-sort-btn').forEach(b => {
        b.classList.toggle('active', b.dataset.sort === sortParam);
      });
    }

    // If color/size filter params in URL on page load, fetch filtered results
    if (activeColors.length > 0 || activeSizes.length > 0) {
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('section_id', 'daniels-collection-products');

      if (grid) { grid.style.opacity = '0.4'; grid.style.pointerEvents = 'none'; }

      fetch(sectionUrl.toString())
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('#danielsProductGrid');
          if (newGrid && grid) {
            grid.innerHTML = newGrid.innerHTML;
            grid.style.opacity = '';
            grid.style.pointerEvents = '';
            initInfiniteScroll();
          }
        })
        .catch(() => {
          if (grid) { grid.style.opacity = ''; grid.style.pointerEvents = ''; }
        });
    }
  })();

  /* ── 10. WISHLIST ──
     Button has onclick attribute that calls danielsWishlist() directly.
     This listener just stops propagation to prevent card click,
     but does NOT call danielsWishlist() again to avoid double-fire.
  ── */
  $$('.daniels-wishlist-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      // danielsWishlist() is called by the onclick attribute on the button
      // Only use this as fallback if no onclick attribute exists
      if (!btn.hasAttribute('onclick') && typeof danielsWishlist === 'function') {
        danielsWishlist(btn, btn.dataset.pid);
      }
    });
  });

  /* ── 11. QUICK VIEW ── */
  $$('.daniels-quick-view').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const url = btn.dataset.productUrl;
      if (url) window.open(url, '_blank', 'noopener');
    });
  });

  /* ── 12. INIT SWIPER ON CARDS ── */
  document.querySelectorAll('.daniels-swiper').forEach(el => {
    const card = el.closest('.daniels-product-card');
    const paginationEl = card ? card.querySelector('.daniels-swiper-pagination') : null;
    const slideCount = el.querySelectorAll('.swiper-slide').length;
    if (window.Swiper) {
      new Swiper(el, {
        loop: slideCount > 1,
        allowTouchMove: true,
        slidesPerView: 1,
        pagination: paginationEl && slideCount > 1 ? {
          el: paginationEl,
          clickable: true,
          type: 'bullets',
        } : false,
      });
    }
  });

  /* ── 13. INFINITE SCROLL (auto-loads next page as user nears the bottom) ── */
  let infiniteScrollObserver = null;

  function initInfiniteScroll() {
    const paginationWrap = document.querySelector('.daniels-pagination');
    if (!paginationWrap) return;

    const loadMoreLink = paginationWrap.querySelector('.daniels-load-more-btn');
    if (!loadMoreLink) return;

    // Hide the button — it stays in the DOM as a fallback if JS fails to load
    loadMoreLink.style.display = 'none';

    // Disconnect any previous observer (e.g. after a filter refresh replaced the grid)
    if (infiniteScrollObserver) infiniteScrollObserver.disconnect();

    let loading = false;

    infiniteScrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !loading) loadNextPage();
      });
    }, { rootMargin: '600px' }); // start fetching before the user actually hits bottom

    infiniteScrollObserver.observe(paginationWrap);

    function loadNextPage() {
      loading = true;

      const spinner = document.createElement('div');
      spinner.className = 'daniels-infinite-spinner';
      spinner.setAttribute('aria-live', 'polite');
      paginationWrap.before(spinner);

      fetch(loadMoreLink.href)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCards = doc.querySelectorAll('.daniels-product-card');
          const currentGrid = document.getElementById('danielsProductGrid');

          newCards.forEach(card => currentGrid.insertBefore(card, paginationWrap));

          // Init Swiper on newly loaded cards
          currentGrid.querySelectorAll('.daniels-product-card .daniels-swiper').forEach(el => {
            if (el._swiper) return;
            const card = el.closest('.daniels-product-card');
            const paginationEl = card ? card.querySelector('.daniels-swiper-pagination') : null;
            const slideCount = el.querySelectorAll('.swiper-slide').length;
            if (window.Swiper) {
              el._swiper = new Swiper(el, {
                loop: slideCount > 1,
                allowTouchMove: true,
                slidesPerView: 1,
                pagination: paginationEl && slideCount > 1 ? { el: paginationEl, clickable: true } : false,
              });
            }
          });

          // Re-bind wishlist fallback on new cards
          currentGrid.querySelectorAll('.daniels-wishlist-btn').forEach(btn => {
            btn.addEventListener('click', e => {
              e.preventDefault(); e.stopPropagation();
              if (!btn.hasAttribute('onclick') && typeof danielsWishlist === 'function') {
                danielsWishlist(btn, btn.dataset.pid);
              }
            });
          });

          spinner.remove();

          const nextLink = doc.querySelector('.daniels-load-more-btn');
          if (nextLink) {
            loadMoreLink.href = nextLink.href;
            loading = false; // ready to trigger again on next scroll
          } else {
            // No more pages left
            infiniteScrollObserver.disconnect();
            paginationWrap.remove();
          }
        })
        .catch(() => {
          spinner.remove();
          loading = false;
        });
    }
  }

  initInfiniteScroll();

  /* ── 14. SWATCH CLICK → SWAP CARD IMAGE ── */
  document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.daniels-swatch');
    if (!swatch || !swatch.dataset.image) return;

    e.preventDefault();
    e.stopPropagation();

    const card = swatch.closest('.daniels-product-card');
    if (!card) return;

    // Mark this swatch active, clear siblings
    card.querySelectorAll('.daniels-swatch').forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');

    // Prefer the currently active swiper slide's image; fall back to the first image
    const activeImg = card.querySelector('.swiper-slide-active .daniels-card-img')
      || card.querySelector('.daniels-card-img');

    if (activeImg) {
      activeImg.src = swatch.dataset.image;
      activeImg.srcset = ''; // clear srcset so the swapped src isn't overridden
    }
  });

  /* ── 15. MATERIAL FILTER — CLIENT-SIDE ON PAGE LOAD ──
     Reads materials stored by Show Results, fetches the collection JSON,
     then shows only matching product cards. Clears after applying.
  ── */
  (function applyMaterialFilterOnLoad() {
    const stored = sessionStorage.getItem('danielsMaterialFilter');
    if (!stored) return;

    let activeMaterials;
    try { activeMaterials = JSON.parse(stored); } catch (e) { return; }
    if (!activeMaterials || activeMaterials.length === 0) return;

    // Re-activate the matching buttons so user sees what's selected
    $$('.daniels-material-btn').forEach(btn => {
      const label = (btn.dataset.label || btn.textContent).trim().toLowerCase();
      if (activeMaterials.includes(label)) btn.classList.add('active');
    });

    const pathParts = window.location.pathname.replace(/\/+$/, '').split('/');
    const collHandle = pathParts[pathParts.length - 1];

    if (grid) { grid.style.opacity = '0.4'; grid.style.pointerEvents = 'none'; }

    fetch(`/collections/${collHandle}/products.json?limit=250`)
      .then(r => r.json())
      .then(({ products }) => {
        const matchingHandles = new Set(
          (products || [])
            .filter(p => activeMaterials.some(mat =>
              (p.tags || []).some(tag => tag.toLowerCase().includes(mat))
            ))
            .map(p => p.handle)
        );

        // Hide any existing Liquid "no products" node first
        grid.querySelectorAll('.daniels-no-products').forEach(el => el.remove());

        $$('.daniels-product-card').forEach(card => {
          const link = card.querySelector('a[href*="/products/"]');
          const handle = link
            ? new URL(link.href, window.location.origin).pathname.split('/products/')[1]?.split('?')[0]
            : null;
          // If handle can't be determined, keep card visible
          card.style.display = (!handle || matchingHandles.has(handle)) ? '' : 'none';
        });

        // Show "no products" only if every card is hidden
        const visible = $$('.daniels-product-card').filter(c => c.style.display !== 'none');
        if (visible.length === 0) {
          const noMsg = document.createElement('p');
          noMsg.className = 'daniels-no-products';
          noMsg.textContent = 'No products found.';
          grid.appendChild(noMsg);
        }

        if (grid) { grid.style.opacity = ''; grid.style.pointerEvents = ''; }
      })
      .catch(() => {
        if (grid) { grid.style.opacity = ''; grid.style.pointerEvents = ''; }
      })
      .finally(() => {
        sessionStorage.removeItem('danielsMaterialFilter');
      });
  })();

  function debounce(fn, wait) {
    let t;
    return function (...args) { clearTimeout(t); t = setTimeout(() => fn.apply(this, args), wait); };
  }

})();